import {
  LoadFirstPageInAppNotifications,
  LoadMoreInAppNotifications,
  LoadSingleInAppNotification,
  ReadInAppNotification,
  DeleteInAppNotification,
  DeleteAllInAppNotifications
} from 'helpers/api-calls/in-app-notifications-calls';

import actions from './actions';

const fetchInAppNotifications = () => (dispatch) => {
  dispatch(actions.requestNotifications(true));
  return LoadFirstPageInAppNotifications().then(({ data }) => {
    dispatch(actions.hydrateNotifications(data.notifications));
  }).catch((error) => {
    console.log(`fetchInAppNotifications error: ${error}`);
  });
};

const fetchMoreInAppNotifications = (pageNum) => (dispatch) => {
  return LoadMoreInAppNotifications(pageNum).then(({ data }) => {
    dispatch(actions.addMoreNotifications(data.notifications));
  });
};

const readSingleNotification = (notificationId) => (dispatch) =>
  ReadInAppNotification(notificationId).then((response) => {
    dispatch(actions.readNotification(notificationId));
  });

const deleteSingleNotification = (notification) => (dispatch) =>
  DeleteInAppNotification(notification.id).then((response) => {
    dispatch(actions.deleteSingleNotification(notification.id));
  });


export default {
  fetchInAppNotifications,
  fetchMoreInAppNotifications,
  deleteSingleNotification,
  readSingleNotification,
};
